var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "VueModal",
    {
      attrs: {
        "modal-class": "modal modal-lg",
        title: "Edit Profile: Our Story",
      },
      model: {
        value: _vm.modalOpen,
        callback: function ($$v) {
          _vm.modalOpen = $$v
        },
        expression: "modalOpen",
      },
    },
    [
      _c("div", [
        _c("div", { staticClass: "mb-12" }, [
          _c("label", { ref: "story", attrs: { for: "story" } }, [
            _vm._v("\n        What’s your organization’s story?\n        "),
            _c("span", { staticClass: "text-sm font-sans-book block" }, [
              _vm._v(
                "\n          900 characters maximum. This is your bio and description, which can include your mission statement, types of resources you provide, and/or what inspired you to do this work. Use I/we when you can; stories are better when they are in your personal voice!\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.story,
                expression: "form.story",
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: "max:900",
                expression: "'max:900'",
              },
            ],
            staticClass:
              "w-full mt-3 p-4 overflow-y-scroll border border-black h-48 bg-transparent",
            attrs: { id: "story", name: "story" },
            domProps: { value: _vm.form.story },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.form, "story", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-sm font-sans-italic text-gray-dark mt-1" },
            [
              _vm._v(
                "\n        Character count: " +
                  _vm._s(_vm.form.story ? _vm.form.story.length : 0) +
                  "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("story"),
                  expression: "errors.has('story')",
                },
              ],
              staticClass: "error text-error-red text-lg",
            },
            [_vm._v("\n      " + _vm._s(_vm.errors.first("story")) + "\n    ")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex justify-center" }, [
          _c(
            "button",
            {
              staticClass: "button",
              attrs: { type: "button" },
              on: { click: _vm.update },
            },
            [_vm._v("\n        Update\n      ")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }